// Morse Falls Risk Scale - estandar clinico para evaluar riesgo de caidas.
// Cada item se puntua segun la opcion seleccionada; la suma total se interpreta:
//   0-24  -> Riesgo bajo
//   25-44 -> Riesgo medio
//   >=45  -> Riesgo alto

export const MORSE_QUESTIONS = [
  {
    key: "history_falling",
    title: "Historial de caidas (en los ultimos 3 meses)",
    opts: [
      { label: "No", score: 0 },
      { label: "Si", score: 25 },
    ],
  },
  {
    key: "secondary_dx",
    title: "Diagnostico secundario (mas de un diagnostico medico activo)",
    opts: [
      { label: "No", score: 0 },
      { label: "Si", score: 15 },
    ],
  },
  {
    key: "ambulatory_aid",
    title: "Ayuda para deambular",
    opts: [
      { label: "Ninguna / reposo en cama / silla de ruedas / acompanada por enfermera", score: 0 },
      { label: "Muletas, baston o andadera", score: 15 },
      { label: "Se apoya en muebles (paredes, mesas, sillas)", score: 30 },
    ],
  },
  {
    key: "iv_lock",
    title: "Cateter intravenoso o heparinizado",
    opts: [
      { label: "No", score: 0 },
      { label: "Si", score: 20 },
    ],
  },
  {
    key: "gait",
    title: "Marcha y transferencia",
    opts: [
      { label: "Normal / reposo / inmovil", score: 0 },
      { label: "Debil (precisa apoyo)", score: 10 },
      { label: "Alterada (insegura, marcha vacilante)", score: 20 },
    ],
  },
  {
    key: "mental_status",
    title: "Estado mental",
    opts: [
      { label: "Conoce y reconoce sus limitaciones", score: 0 },
      { label: "Olvida o sobreestima sus limitaciones", score: 15 },
    ],
  },
];

const MORSE_KEYS = ["history_falling", "secondary_dx", "ambulatory_aid", "iv_lock", "gait", "mental_status"];

export function isMorseFilled(morse) {
  if (!morse) return false;
  return MORSE_KEYS.some((k) => morse[k] !== null && morse[k] !== undefined);
}

export function isMorseComplete(morse) {
  if (!morse) return false;
  return MORSE_KEYS.every((k) => morse[k] !== null && morse[k] !== undefined);
}

export function computeMorseTotal(morse) {
  if (!morse) return 0;
  return MORSE_KEYS.reduce(
    (s, k) => s + (Number.isFinite(morse[k]) ? Number(morse[k]) : 0),
    0
  );
}

export const MORSE_LEVELS = {
  low:    { label: "Riesgo bajo",    color: "#15803D", bg: "#D1FAE5", dot: "#10B981" },
  medium: { label: "Riesgo medio",   color: "#854D0E", bg: "#FEF3C7", dot: "#F59E0B" },
  high:   { label: "Riesgo alto",    color: "#B91C1C", bg: "#FEE2E2", dot: "#DC2626" },
};

export function morseLevel(total) {
  if (total >= 45) return { key: "high", ...MORSE_LEVELS.high };
  if (total >= 25) return { key: "medium", ...MORSE_LEVELS.medium };
  return { key: "low", ...MORSE_LEVELS.low };
}
